export const getCustomerReferenceNumber = () => {
  return localStorage.getItem('selectedCusRef') || '';
};
